import React from "react";
import { useState } from "react";
import { Tooltip } from "reactstrap";

const DrugName = ( rowData) => {
const [tooltipOpen, setTooltipOpen] = useState(false);
  const description = rowData.drugname;
  const displayText =
    description.length > 15
      ? `${description.substring(0, 14)}...`
      : description;

      const onToggle =() =>{
        setTooltipOpen(!tooltipOpen)

      }
      const tooltipId = `Tooltip-${rowData.id}`;

  return (
    <div>
      <span id={tooltipId} style={{cursor:"pointer"}}> {displayText}</span>
      <Tooltip
        isOpen={tooltipOpen}
        placement="bottom"
        target={tooltipId}
        toggle={(rowData) =>onToggle(rowData)}
      >
        {description}
      </Tooltip>
    </div>
  );
};

export default DrugName;
